
let domLoaded = false;
let igReady = false;

function handleExperiments() {
  if (!domLoaded || !igReady) return;

  // V_TIME_CART_13 concluded as LOSER — all traffic falls back to the V_TIME_CART_04 baseline it was tested against.
  document.body.classList.add("c-V_TIME_CART_04-test");

  // V_TIME_PDP_14 | Trust Policies Below ATC - PDP
  const V_TIME_PDP_14 = window.igData?.user.getTestGroup("a621b86c-0de7-445f-8afa-54745703e5a4");

  if (V_TIME_PDP_14?.name === "Var A") {
    document.body.classList.add("c-V_TIME_PDP_14-test");
  }

  // V_TIME_CART_17 | Cart USP Trust Strip 
  const V_TIME_CART_17 = window.igData?.user.getTestGroup("23d55977-395a-4efc-a4a3-2bbc2abafd93");

  if (V_TIME_CART_17?.name === "Var A") {
    document.body.classList.add("c-V_TIME_CART_17-test");
  }

}

document.addEventListener("DOMContentLoaded", () => {
  domLoaded = true;
  handleExperiments();
});

window.addEventListener("ig:ready", () => {
  igReady = true;
  handleExperiments();
});